import * as R from 'ramda'

/**
 * This removes keys with null, undefined, empty values from object
 * @param obj
 * @returns {f1}
 */
const cleanJson = obj => {
  for (let key in obj) {
    let val = obj[key]
    if (val && typeof val === 'object' && !Array.isArray(val)) {
      cleanJson(val)
    } else if (R.isNil(val) || val === '') {
      delete obj[key]
    }
  }
  return obj
}

export default cleanJson
